/* @flow */

export const REDUX_MSG_APPLICATION_REGISTER: 'REDUX_MSG_APPLICATION_REGISTER' = 'REDUX_MSG_APPLICATION_REGISTER';
export const REDUX_MSG_APPLICATION_UNREGISTER: 'REDUX_MSG_APPLICATION_UNREGISTER' = 'REDUX_MSG_APPLICATION_UNREGISTER';
export const REDUX_MSG_ASSOCIATED_DEVICES_UPDATE: 'NTG_RDX_MSG_ASSOCIATED_DEVICES' = 'NTG_RDX_MSG_ASSOCIATED_DEVICES';
export const REDUX_MSG_SET_DEVICE_ID: 'NTG_RDX_MSG_SET_DEVICE_ID' = 'NTG_RDX_MSG_SET_DEVICE_ID';
export const REDUX_MSG_UPDATE_AUTHENTICATION_TOKEN: 'NTG_RDX_MSG_LOGGED' = 'NTG_RDX_MSG_LOGGED';
export const REDUX_MSG_USER_INFO_RESET: 'REDUX_MSG_USER_INFO_RESET' = 'REDUX_MSG_USER_INFO_RESET';
export const REDUX_MSG_USER_INFO_UPDATE: 'REDUX_MSG_USER_INFO_UPDATE' = 'REDUX_MSG_USER_INFO_UPDATE';
